import brand from '@helpers/brand';
import { siteWide } from '@helpers/grid';
import styled from 'styled-components';
const Container = styled.section `
  scroll-margin: var(--headerHeight) 0 0;
  background: var(--sectionBackground, transparent);

  &[data-flush='top'] {
    --sectionSpacingTop: 0;
  }

  &[data-flush='bottom'] {
    --sectionSpacingBottom: 0;
  }

  &[data-flush='both'] {
    --sectionSpacingTop: 0;
    --sectionSpacingBottom: 0;
  }

  &[data-theme='blue'] {
    --sectionBackground: ${brand.primary.blue};
  }

  &[data-theme='grey'] {
    --sectionBackground: ${brand.grey.light};
  }

  &[data-theme='white'] {
    --sectionBackground: ${brand.global.white};
  }

  &[data-theme='blue-gradient'],
  &[data-theme='green-gradient'],
  &[data-theme='orange-gradient'],
  &[data-theme='purple-gradient'],
  &[data-theme='red-gradient'] {
    --gradStart: ${brand.primary.blue};
    --sectionBackground: linear-gradient(83deg, var(--gradStart) 18.5%, var(--gradEnd) 82%);
  }

  &[data-theme='blue'],
  &[data-theme='blue-gradient'],
  &[data-theme='green-gradient'],
  &[data-theme='orange-gradient'],
  &[data-theme='purple-gradient'],
  &[data-theme='red-gradient'] {
    color: ${brand.global.white};
  }

  &[data-theme='blue-gradient'] {
    --gradEnd: ${brand.primary.cyan};
  }

  &[data-theme='green-gradient'] {
    --gradEnd: ${brand.primary.green};
  }

  &[data-theme='orange-gradient'] {
    --gradEnd: ${brand.primary.orange};
  }

  &[data-theme='purple-gradient'] {
    --gradEnd: ${brand.primary.purple};
  }

  &[data-theme='red-gradient'] {
    --gradEnd: ${brand.primary.red};
  }
`;
const Inner = styled.div `
  ${siteWide};

  padding-top: var(--sectionSpacingTop);
  padding-bottom: var(--sectionSpacingBottom);
`;
const SectionWrapperStyles = {
    Container,
    Inner,
};
export default SectionWrapperStyles;
